import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  OrderWrapper,
  MedDetailsWrap,
  MedSubBtn,
  BottomWrap,
  OrderLabel,
  SubOrderLabel,
} from "./MissingMed.styled";
// import "../PickerOrder/PickerOrder.css";
import { Input, Button, message, Empty, Modal } from "antd";
import { fetchMissingMedDetailsThunk } from "../../redux/PickerOrder/Action";
import { fetchMissingMedThunk } from "../../redux/MissingMedDashboard/action";
import { savePickerMissingMedicineDetails } from "../../redux/NewPickerRedux/Action";
import IncrementDecrementInput from "../../components/IncrementDecrementInput/IncrementDecrementInput";
import packageIcon from "../../assets/icons/package.png";
import { ROLES, warehouseId } from "../../constants/index";
import TitleWrapper from "../../components/TitleWrap/TitleWrap";
import { Dialog } from "@material-ui/core";
import {
  Button as ButtonNew,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import { Base64func } from "../../components/Base64Func/Base64func";
import OfflinePage from "../OfflinePage/OfflinePage";
import {
  getOrderDetailsThunk,
  confirmMissingMedThunk,
} from "../../redux/NewOrderDetails/action";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";
import { AiOutlineScan } from "react-icons/ai";

export class MissingMed extends Component {
  state = {
    orderId: "",
    // currentWarehouseId: null,
    isSearched: false,
    missingMedList: [],
    missingMedsModal: false,
    reasonMaster: null,
    currentOrderData: null,
    showScannerScreen: false,
    enableEditBtn: false,
    visibleSubmit: false,
  };

  componentDidMount() {
    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");

    let orderValue = "";
    // let warehouseValue = "";

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );
    // currPathArr.map((item) =>
    //   item.includes("warehouseId") ? (warehouseValue = item.split("=")[1]) : ""
    // );

    this.setState(
      {
        orderId: Base64func(orderValue, "decode"),
        // currentWarehouseId: warehouseValue,
      },
      () => {
        if (
          this.props.userInfo &&
          this.props.userInfo.role &&
          !this.props.userInfo.role.find(
            (o) => o.roleName === ROLES.ADMIN_PICKER_ROLE
          )
        ) {
          message.error("Please contact picker admin to process this order");
          this.props.history.push("/markorder");
        } else {
          this.fetchMissingMedDetails();
        }
      }
    );
  }

  updateBoxId = (value) => {
    if (value) {
      this.setState({ enableEditBtn: true });
    }
    this.setState({ showScannerScreen: false });
  };

  fetchMissingMedDetails = () => {
    message.loading("Loading data...", 0);
    this.props
      .fetchMissingMedThunk({
        access_token: this.props.access_token,
        warehouseId: warehouseId,
        history: this.props.history,
        orderId: this.state.orderId,
      })
      .then(() => {
        if (this.props.missingMedData?.fetchMissingMedError) {
          message.destroy();
          message.error(this.props.missingMedData.fetchMissingMedError);
        } else if (
          this.props.missingMedData?.fetchMissingMedData
            ?.missingMedicineDetailsList.length >= 0
        ) {
          this.setState(
            {
              missingMedList: this.filterDataByOrderId(
                this.props.missingMedData.fetchMissingMedData
                  .missingMedicineDetailsList
              ),
              reasonMaster: this.props.missingMedData.fetchMissingMedData
                ?.reasonMasterList,
            },
            () => {
              message.destroy();

              let data = {
                orderId: this.state.orderId,
                // orderId: 940,
                warehouseId: warehouseId,
                access_token: this.props.access_token,
                history: this.props.history,
              };

              this.props.getOrderDetailsThunk(data).then(() => {
                if (this.props.newOrderDetails?.newOrderDetailsError) {
                  message.error(
                    this.props.newOrderDetails?.newOrderDetailsError
                  );
                } else {
                  this.setState({
                    currentOrderData: this.props.newOrderDetails
                      .newOrderDetailsSuccess,
                  });
                }
              });
            }
          );
        } else {
          message.destroy();
        }
      });
  };

  getOrderIds = (arr) => {
    let finalArr = [];
    for (let i in arr) {
      let order = arr[i];
      if (finalArr.indexOf(order.orderId) === -1) {
        finalArr.push(order.orderId);
      }
    }
    return finalArr;
  };

  getProductCodes = (arr) => {
    let finalArr = [];
    for (let i in arr) {
      let med = arr[i];
      if (finalArr.indexOf(med.productCode) === -1) {
        finalArr.push(med.productCode);
      }
    }
    return finalArr;
  };

  filterDataByOrderId = (arr) => {
    let orderSortedArray = [];
    let allOrderIds = this.getOrderIds(arr);
    if (allOrderIds?.length > 0) {
      for (let i in allOrderIds) {
        let orderId = allOrderIds[i];
        let medArr = [];
        for (let j in arr) {
          let order = arr[j];
          if (order.orderId === orderId) {
            medArr.push(order);
          }
        }
        let medList = [];
        let allProductCodes = this.getProductCodes(medArr);
        allProductCodes.map((f) => {
          let tempArray = [];
          medArr.map((e) => {
            if (e.productCode === f) {
              e.ogQty = e.quantity;
              tempArray.push(e);
            }
          });
          medList.push({
            name: tempArray[0].name,
            batches: tempArray,
            productCode: tempArray[0].productCode,
          });
        });
        medList = medList.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );
        orderSortedArray.push({ orderId: medArr[0].orderId, MedList: medList });
      }
    }
    return orderSortedArray;
  };

  editMedDetails = (e, isActive) => {
    let arr = this.state.missingMedList;
    arr.map((f) => {
      if (f.orderId === e.orderId) {
        e.activeMed = isActive;
      }
    });
    let pickedReason = this.state.reasonMaster.find(
      (i) => i.value === "Picked"
    );

    this.setState({ missingMedList: arr }, () => {
      if (!isActive) {
        let finalArr = [];
        let batchesArr = this.getAllBatches(e.MedList);
        if (batchesArr?.length > 0) {
          for (let i in batchesArr) {
            let batch = batchesArr[i];

            let newBatch = {};
            newBatch.active = batch.quantity ? true : false;
            newBatch.batchNumber = batch.batchNumber;
            newBatch.id = batch.id;
            newBatch.name = batch.name;
            newBatch.orderId = batch.orderId;
            newBatch.productCode = batch.productCode;
            newBatch.quantity = batch.quantity ? batch.quantity : batch.ogQty;
            newBatch.warehouseId = warehouseId;
            newBatch.invoiceBatchtId = batch.invoiceBatchtId;
            newBatch.reasonId = batch.quantity
              ? batch.reasonId
              : pickedReason.reasonId;

            finalArr.push(newBatch);
          }
        }
        if (finalArr?.length > 0) {
          let data = {
            access_token: this.props.access_token,
            missingMedicineDetailsList: finalArr,
            history: this.props.history,
            lastMed: true,
          };
          message.loading("Saving...", 0);
          this.props.savePickerMissingMedicineDetails(data).then(() => {
            message.destroy();
            if (this.props.newPickerDetails?.missingMedsError) {
              message.error(this.props.newPickerDetails.missingMedsError);
            } else {
              this.fetchMissingMedDetails();
            }
          });
        } else {
          message.error("No change detected");
        }
      }
    });
  };

  getAllBatches = (meds) => {
    let finalArr = [];
    for (let i in meds) {
      let med = meds[i];
      finalArr.push(...med.batches);
    }
    return finalArr;
  };

  handleBatchEdit = (qty, orderKey, medKey, batchkey) => {
    let medicineList = this.state.missingMedList;
    medicineList[orderKey].MedList[medKey].batches[batchkey].quantity = qty;
    this.setState({ missingMedList: medicineList });
  };

  submitProducrement = () => {
    message.loading("Loading...", 0);

    let data = {
      access_token: this.props.access_token,
      warehouseId: warehouseId,
      history: this.props.history,
      orderId: this.state.orderId,
    };

    this.props.confirmMissingMedThunk(data).then(() => {
      message.destroy();
      if (this.props.newOrderDetails.confirmMissingMedError) {
        message.error(this.props.newOrderDetails.confirmMissingMedError);
        this.setState({ visibleSubmit: false });
      } else {
        message.success(this.props.newOrderDetails.confirmMissingMedSuccess);
        this.setState({ visibleSubmit: false });
        this.props.history.push("/missing_med_dashboard");
      }
    });
  };

  render() {
    return (
      <div className="centerScreen">
        {this.props.isOnline ? (
          <div>
            {this.state.missingMedList?.length > 0 ? (
              <div>
                {this.state.missingMedList.map((e, i) => (
                  <div
                    style={{
                      margin: "15px 0px",
                      borderRadius: "4px",
                      // boxShadow: "0 2px 8px rgb(28 28 28 / 14%)",
                      padding: "6px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <OrderLabel>
                        Order Id : &nbsp; <span>{e.orderId}</span>
                      </OrderLabel>
                      <SubOrderLabel>
                        RackName: &nbsp;{" "}
                        <span>
                          {this.state.currentOrderData?.rackName
                            ? this.state.currentOrderData?.rackName
                            : "-"}
                        </span>
                      </SubOrderLabel>
                    </div>
                    {e.MedList.map((med, medKey) => (
                      <MedDetailsWrap>
                        <div className="medTitleWrap">
                          <div className="medTitle">{med.name}</div>
                        </div>
                        <div className="batchWrap">
                          {med.batches?.length > 0 ? (
                            med.batches.map((f, j) => {
                              return (
                                <div className="batchDetailsWrap">
                                  <div className="name">{f.batchNumber}</div>
                                  <div className="qty">{f.ogQty}</div>
                                  <div className="editQty">
                                    <IncrementDecrementInput
                                      disabled={!e.activeMed}
                                      min={0}
                                      max={f.ogQty}
                                      value={f.quantity}
                                      step={1}
                                      handleChange={(qty) => {
                                        this.handleBatchEdit(qty, i, medKey, j);
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div>No Batches Found</div>
                          )}
                        </div>
                      </MedDetailsWrap>
                    ))}
                    <button
                      className="bbtn"
                      style={{ marginTop: "2em" }}
                      onClick={() =>
                        this.editMedDetails(e, e.activeMed ? false : true)
                      }
                      disabled={!this.state.enableEditBtn}
                    >
                      {e.activeMed ? "Save" : "Edit"}
                    </button>

                    <button
                      className="bbtn"
                      onClick={() => this.setState({ showScannerScreen: true })}
                      style={{ marginTop: "2em" }}
                    >
                      <AiOutlineScan /> Scan the barcode
                    </button>

                    <button
                      className="bbtn"
                      onClick={() => this.setState({ visibleSubmit: true })}
                      style={{ marginTop: "2em" }}
                    >
                      Submit for procurement
                    </button>

                    {this.state.showScannerScreen && (
                      <BarcodeScanner
                        scan={this.state.showScannerScreen ? true : false}
                        camera={this.state.showScannerScreen ? true : false}
                        redirect="missingDashRack"
                        boxId={this.state.currentOrderData?.boxNumber}
                        history={this.props.history}
                        getBoxId={this.updateBoxId}
                      />
                    )}

                    <Modal
                      title={`Submit order #${this.state.orderId} procurement`}
                      visible={this.state.visibleSubmit}
                      onOk={this.submitProducrement}
                      onCancel={() => this.setState({ visibleSubmit: false })}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15px",
                }}
              >
                <Empty
                  style={{ margin: "5vh 0" }}
                  description="No Medicine found"
                />
              </div>
            )}
          </div>
        ) : (
          <OfflinePage />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  missingMedData: state.missingMedDashReducer,
  newPickerDetails: state.newPickerOrderReducer,
  isOnline: state.statusReducer?.isOnline,
  newOrderDetails: state.newOrderDetailsReducer,
});

const mapDispatchToProps = {
  fetchMissingMedDetailsThunk,
  savePickerMissingMedicineDetails,
  fetchMissingMedThunk,
  getOrderDetailsThunk,
  confirmMissingMedThunk,
};

export default connect(mapStateToProps, mapDispatchToProps)(MissingMed);
